import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M14.116 6.68a.5.5 0 0 1 .704-.064l6 5a.5.5 0 0 1 0 .768l-6 5a.5.5 0 0 1-.64-.768l4.939-4.116H3.5a.5.5 0 1 1 0-1h15.619l-4.94-4.116a.5.5 0 0 1-.063-.704"
}), 'ArrowRightSubmit');
//# sourceMappingURL=index.js.map